module.exports = __webpack_public_path__ + "static/other/gameWaiterMemory.e1418ac7.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameWaiterMemory.json
// module id = 2516
// module chunks = 0